export interface MenuOption {
    key: string;
    name: string;
    path: string;
}

/** Nav menu items shown to authenticated users. */
export const loggedInUserMenuOptions: MenuOption[] = [
    { key: 'ReportALeak', name: "Report a Gas Leak", path: "https://www.socalgas.com/safety/safety-and-prevention/natural-gas-leak" },
    { key: 'ContactUs', name: "Contact Us", path: "https://www.socalgas.com/about-us/contact-us" },
    { key: 'HelpCenter', name: "Help Center", path: "https://www.socalgas.com/help-center" },
  /*   { key: 'home', name: 'Notice of Intent to Perform Fumigation Close / Restore', path: '/' }, */
    { key: 'admin', name: 'Admin', path: '/admin' },
];

export const userProfileOptions = [
    { key: 'signout', value: 'Sign Out', text: 'Sign Out' },
];

export const pageTitle = 'Notice of Intent to Perform Fumigation Close / Restore';
